import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

/**
 * Apply filters after user changes <select> options.
 */
function stavoorPlatformApplyFilters() {
	('use strict');

	const form = document.querySelector('#filter-form');
	const filters = document.querySelectorAll('#filter-form select');
	const button = document.querySelector('#filter-form button');

	if (!filters || !form) {
		return false;
	}

	const targetUrl = new URL(form.getAttribute('action'));

	button.addEventListener('click', (e) => {
		e.preventDefault();

		for (const filter of filters) {
			if (filter.value) {
				targetUrl.searchParams.append(
					filter.getAttribute('name'),
					filter.value
				);
			}
		}

		document.location = targetUrl;
	});

	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);

	if (0 < params.size) {
		document.querySelector('#filter-form').scrollIntoView({
			behavior: 'instant',
		});
	}
}
window.addEventListener('load', stavoorPlatformApplyFilters, {
	passive: true,
});

window.stavoorPlatformApplyPostsPerPage = function (e) {
	('use strict');

	const inputUrl = new URL(e.getAttribute('data-archiveurl'));
	inputUrl.search += '&posts_per_page=' + e.value;
	document.location = inputUrl.href;
};

function stavoorPlatformMenuDetailsToggle() {
	('use strict');

	const detailsElement = document.querySelector('.page-heading details');
	if (!detailsElement) {
		return false;
	}

	if (window.matchMedia('(min-width: 1200px').matches) {
		detailsElement.open = true;
	} else {
		detailsElement.open = false;
	}
}
window.addEventListener('load', stavoorPlatformMenuDetailsToggle, {
	passive: true,
});
window.addEventListener('resize', stavoorPlatformMenuDetailsToggle, {
	passive: true,
});

function stavoorPlatformToggleSearch() {
	('use strict');

	const searchToggles = document.querySelectorAll(
		'a[href="#zoeken"], button.search-toggle'
	);
	if (!searchToggles) {
		return false;
	}

	for (const searchToggle of searchToggles) {
		searchToggle.addEventListener('click', (e) => {
			e.preventDefault();
			document.body.classList.toggle('search--visible');

			if (document.body.classList.contains('search--visible')) {
				document
					.querySelector('form.search-form input[type="search"]')
					.focus();
			}
		});
	}
}
window.addEventListener('load', stavoorPlatformToggleSearch, {
	passive: true,
});

function stavoorPlatformToggleTooltips() {
	('use strict');

	// Abort if on touch device.
	if (
		'ontouchstart' in window ||
		(window.DocumentTouch && document instanceof DocumentTouch)
	) {
		return false;
	}

	const tooltipTriggerList = document.querySelectorAll(
		'[data-bs-toggle="tooltip"]'
	);
	[...tooltipTriggerList].map(
		(tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
	);
}
window.addEventListener('load', stavoorPlatformToggleTooltips, {
	passive: true,
});

function stavoorPlatformToggleCanvas() {
	('use strict');

	const canvasToggle = document.querySelector('.menu-toggle');
	if (!canvasToggle) {
		return false;
	}

	canvasToggle.addEventListener('click', () => {
		canvasToggle.classList.toggle('is-active');
		document.body.classList.toggle('canvas--visible');
	});
}
window.addEventListener('load', stavoorPlatformToggleCanvas, {
	passive: true,
});
